import { useEffect } from 'react'

import { useSelector } from '@tabeeb/store'
import { getTrainingMaterialsTitle } from '@tabeeb/modules/appConfigState/selectors'

import { trainingMaterialTitleFormatter } from './TrainingMaterialTitleFormatter'

const useTrainingMaterialTitleFormatter = () => {
  const title = useSelector(getTrainingMaterialsTitle)

  useEffect(() => {
    trainingMaterialTitleFormatter.setTitle(title)
  }, [title])

  return { f: trainingMaterialTitleFormatter.format.bind(trainingMaterialTitleFormatter) }
}

export default useTrainingMaterialTitleFormatter
